module.exports = __webpack_public_path__ + "img/foot-ico.d9e6cdf7.svg";